import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import {API_BASE_URL, SITE_NAME} from '../../constants'
import {setSessionPhone} from '../../storage'
import { CenterTitle} from '../header'
import axios from 'axios'

class ForgotPassword extends Component {


  constructor(props) {
    super(props)
    this.lookupPhone = this.lookupPhone.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.state = {phone:''}
    document.title = "Forgot Password - Goods Bill"
  }

  handleInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  lookupPhone(e) {
    this.setState({error_response_data: undefined})
    e.preventDefault()
    axios({
      baseURL: API_BASE_URL,
      url:"/lookup_phone/",
      method:"POST",
      data:{phone:this.state.phone}
    }).then((response)=>{

      setSessionPhone(response.data.phone)
      this.props.history.push('/verify_forgot_pass_otp/')
    }).catch(err=>{

      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        this.setState({error_response_data:err.response.data})
      }

    })
  }


  render() {

    let error_response_data = this.state.error_response_data
    let errors
    let phone_error
    if(typeof error_response_data !== "undefined") {
      errors = error_response_data.errors
      console.log(errors);
      if(typeof errors.phone !== "undefined" && errors.phone.length > 0) {
        phone_error = errors.phone[0]
      }
    }
    return (
      <div>

        <section>
          <div className="container">
              <div className="row">
                <div className="col-sm-6 col-sm-offset-3">
                  <div className="">
                        <CenterTitle />
                        <section className="small">
                        <h1 className="text-center">Forgot Password ?</h1>
                        </section>
                        <form onSubmit={this.lookupPhone}>
                          <div className="form-group">
                          <label htmlFor="phone">Enter your registered phone number</label>
                            <div className="input-group">
                              <div className="input-group-addon">+91</div>
                              <input type="text" name="phone" className="form-control " onChange={this.handleInputChange} value={this.state.phone} />
                            </div>
                          </div>
                          <span className="text-danger">{phone_error}</span>
                          <div className="form-group">
                            <input type="submit" className="btn btn-primary btn-block" value="Submit" />
                          </div>
                        </form>

                  </div>
                </div>
              </div>
          </div>

        </section>
      </div>
    )
  }
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/components/auth/forgotpass.js